export default "__VITE_ASSET__B66tAESZ__"